import { render } from "./BurgerForm.vue?vue&type=template&id=74bec79a&scoped=true"
import script from "./BurgerForm.vue?vue&type=script&lang=js"
export * from "./BurgerForm.vue?vue&type=script&lang=js"

import "./BurgerForm.vue?vue&type=style&index=0&id=74bec79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bec79a"]])

export default __exports__